var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4-2h30v30H-4z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#80959D"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M3.75 6.21V.71h19v18l-2.938-3.096-1.196 1.494"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M.678 6.468v18.616l2.872-2.787 2.93 2.548 3.005-2.822 3.067 2.822 3.067-2.822 3.06 2.822V6.264z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 11h6M4 14h9.432M4 17h9.432"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalOrders);
export default __webpack_public_path__ + "static/media/total-orders.16e89d8d4577495cc21e4f0f6ccaea0a.svg";
export { ForwardRef as ReactComponent };